import template from './acceptableAccordion.html';

export const acceptableAccordionComponent = {
  name: 'acceptableAccordion',
  restrict: 'E',
  transclude: true,
  template
};
